import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-reason-feedback',
  templateUrl: './delete-reason-feedback.component.html',
  styleUrls: ['./delete-reason-feedback.component.scss'],
})
export class DeleteReasonFeedbackComponent implements OnInit {
  public feedback = '';

  constructor(private dialogRef: MatDialogRef<DeleteReasonFeedbackComponent>) {}

  ngOnInit() {}

  cancelClicked() {
    this.dialogRef.close();
  }

  deleteClicked() {
    this.dialogRef.close(this.feedback);
  }
}
